export function formatCurrencySpacing(str: string) {
  // Use regex to add a space between number and currency symbols/letters
  return str
    .replace(/(\d)([a-zA-Z]+)/g, "$1 $2")
    .replace(/([a-zA-Z]+)(\d)/g, "$1 $2");
}

export function reverseWords(str: string) {
  return str.split(" ").reverse().join(" ");
}

export function extractCurrency(str: string) {
  const regex = /[^\d\s]+/g;
  const result = str.match(regex);

  return result ? result[0] : null;
}

// Helper function to get the day of the week from a date string
export const getDayOfWeek = (date: string): string => {
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const [day, month, year] = date.split(".");
  const formattedDate = `${year}-${month}-${day}`;
  const d = new Date(formattedDate);

  return days[d.getDay()];
};

export const optionsInGerman: any = {
  Monday: "Montag",
  Tuesday: "Dienstag",
  Wednesday: "Mittwoch",
  Thursday: "Donnerstag",
  Friday: "Freitag",
  Saturday: "Samstag",
  Sunday: "Sonntag",
};
